import { render, staticRenderFns } from "./PropertyModal.vue?vue&type=template&id=ef7cb4a4&"
import script from "./PropertyModal.vue?vue&type=script&lang=js&"
export * from "./PropertyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports